import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
// import PropTypes from 'prop-types'
import {
  setBusy,
  clearBusy,
} from '../../../irmlib/src/containers'
import moment from 'moment'
import { Box, Typography, Grid, Link } from '@mui/material'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import MaterialTable from '../../Controls/MaterialReactTable'
import { useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import GoBackSubtitle from '../../Controls/GoBackSubtitle'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)``

const BoxTransmittalExceptionDetails = (props) => {
  const [transmittalData, setData] = React.useState([])
  // eslint-disable-next-line
  const [templateDataList, setTemplateDataList] = useState(false)
  const { state } = useLocation()
  const history = useHistory()
  const { t } = useTranslation()
  // eslint-disable-next-line
  const { label: stateLabel, exceptionType, district, building } = state || {}

  

  useEffect(async() => {
    getPageData()
  }, [templateDataList])

  const dataRet = async () => {
    setBusy()
    // let collection
    // if (templateDataList) {
    //   collection = templateDataList
    // } else {
    //   collection = await gdeTransactions.getBoxTransmittalsListener(
    //     'normal',
    //     val,
    //     false
    //   )
    // }
    const collection = await gdeTransactions.getBoxTransmittalsExcepDetail(exceptionType, district, building)
    let activityList = []
    const activityListIDP = []
    const activityListHITL = []
    const promises = []
    collection?.docs?.forEach(async (doc) => {
      const docData = doc.data()
      const { id, accountLevel1, building, formatError, status, createdTs, imgDetails, imgReference, template, wmsStatus, wmsRegion, idp } = docData
      let dateOfCreation = false
      if (createdTs) {
        dateOfCreation = moment(createdTs.seconds, 'X').format('YYYY-MM-DD')
      }

      if (dateOfCreation === 'Invalid date') {
        dateOfCreation = createdTs.substring(0, 10)
      }
      const templateFields = Object.keys(template).map((key) => {
        // eslint-disable-next-line
        const data = key + '(' + template[key].fieldId + ')' + ',' + ' '
        return data
      })
      if (exceptionType === 'hitlReject' && (idp?.statusCode === 'IDP-501' || idp?.statusCode === 'IDP-502' || idp?.statusCode === 'IDP-599')) {
        activityListHITL.push({
          id: id,
          customerId: accountLevel1,
          building: building,
          formatError: formatError,
          status: status,
          dateCreated: dateOfCreation,
          imgDetails: imgDetails,
          imgReference: imgReference,
          wmsStatus: wmsStatus,
          wmsRegion: wmsRegion,
          fields: templateFields,
          exception: idp?.exception
        })
      }
      if (exceptionType === 'idpFailure' && (idp?.statusCode === 'IDP-401' || idp?.statusCode === 'IDP-402')) {
        activityListIDP.push({
          id: id,
          customerId: accountLevel1,
          building: building,
          formatError: formatError,
          status: status,
          dateCreated: dateOfCreation,
          imgDetails: imgDetails,
          imgReference: imgReference,
          wmsStatus: wmsStatus,
          wmsRegion: wmsRegion,
          fields: templateFields,
          exception: idp?.exception
        })
      }
      activityList.push({
        id: id,
        customerId: accountLevel1,
        building: building,
        formatError: formatError,
        status: status,
        dateCreated: dateOfCreation,
        imgDetails: imgDetails,
        imgReference: imgReference,
        wmsStatus: wmsStatus,
        wmsRegion: wmsRegion,
        fields: templateFields,
        exception: idp?.exception
      })
    })
    await Promise.all(promises)
    if (exceptionType === 'idpFailure') {
      setData(activityListIDP)
      activityList = [...activityListIDP]
    } else if (exceptionType === 'hitlReject') {
      setData(activityListHITL)
      activityList = [...activityListHITL]
    } else {
      setData(activityList)
    }
    clearBusy()
    return activityList
  }

  const getPageData = async (page, pageSize) => {
    try {
      const data = await dataRet()
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching page data:', error)
      return []
    }
  }

  const handleGoBack = () => {
    history.goBack()
  }
  
  // Breadcrumbs
  const breadcrumbs = [
    <Link underline='hover' onClick={() => handleGoBack()} color='primary' style={{ cursor: 'pointer' }}>
      {t('smartCatalog.smartCatalogDashBoard')}
      {/* Smart Catalog Dashboard */}
    </Link>,
    <Typography sx={{ color: 'text.primary' }}>
      {t('routeTitles.boxTransmittals')}
      
    </Typography>,
    <Typography sx={{ color: 'text.primary' }}>
      {t(`transmittalTypeObj.${exceptionType}`)}
    </Typography>,
  ]

  const BreadCrumbsComponent = () => {
    return (
      <Breadcrumbs separator='›' aria-label='breadcrumb'>
        {breadcrumbs}
      </Breadcrumbs>
    )
  }

  return (
    <>
      <MainRouteSubRoutePage
        mainTitle={t(`transmittalTypeObj.${exceptionType}`)}
        subTitle={<><GoBackSubtitle id={'BoxImageDetails_goBack'} />
          <BreadCrumbsComponent /></>}
      >
        <TableContainer>
          <Box boxShadow={3} borderRadius={4} sx={{ margin: '15px' }}>
            <Grid item container sx={{ padding: '10px 15px 0px' }}>
              <Grid item container alignItems={'center'}>
                <Typography variant='h6' gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
                  {/* {t('routeTitles.viewBoxTransmittals')} */}
                  {t(`transmittalTypeObj.${exceptionType}`)}
                </Typography>
              </Grid>
            </Grid>
            <MaterialTable
              data={transmittalData}
              tableFor='smart_catalog_view_transmittals'
            />
          </Box>
        </TableContainer>
      </MainRouteSubRoutePage>
    </>
  )
}
BoxTransmittalExceptionDetails.propTypes = {
//   FilterData: PropTypes.object,
  // DataSearch: PropTypes.string,
}

export default BoxTransmittalExceptionDetails
